import {
  assetExtensionsFromServer,
  ButtonClickType,
  UploadTypes,
} from "../constants/commons";

export interface ISelectOption {
  label: string;
  value: Object;
}

export interface ITableInlineComponentProps {
  index: number;
  row: any;
  [prop: string]: any;
}

export interface navigationPagePropType {
  nextScreen: string;
  prevScreen: string;
}

// TODO: Move this to the Commons folder (Type for GENDER)
export enum Gender {
  MALE = "Male",
  FEMALE = "Female",
  OTHER = "Other",
}

// TODO: Move this to the Commons folder (Type for YES/NO)
export enum BooleanTypes {
  YES = "YES",
  NO = "NO",
}

// TODO: Move this to the Commons folder (Type for PROFESSIONS)
export enum ProfessionTypes {
  FITNESS_TRAINER = "Fitness Trainers",
  PHYSIOTHERAPIST = "Physiotherapist",
  GYMNIST = "Gymnist",
}

// TODO: Move this to the Commons folder (Type for PreliminaryQuizInfo)
export interface PreliminaryQuizInfo {
  studyMaterial: {
    name: string;
    thumbnailUrl?: string;
    category?: string;
    description?: string;
  }[];
}

// TODO: Move this to the Commons folder (Type for Basic Information Screen)
export interface BasicInfo {
  leadId: string;
  name: string;
  gender: Gender;
  email: string;
  phoneNumber: string;
  profilePicture: {
    isUploaded: boolean;
    fileExtension: string;
    filename: string;
    data?: any;
    url?: any;
  };
  address: {
    city: string;
    state: string;
    country: string;
    zipcode: string;
  };
}

// TODO: Move this to the Commons folder (Type for Language Proficiency Screen )
export interface LanguageProficiencyInfo {
  isComfortableInEnglish: BooleanTypes;
  languagesKnown: string[];
}

// TODO: Move this to the Commons folder (Type for Professional Details Screen )
// TODO: Move this to the commons Folder (Type for the Professional Page)
export interface ProfessionInfo {
  monthsOFExperience: number;
  graduationDegree: string[];
  postGraduationDegree: string[];
  otherCertifications?: string[];
  medicalRegistrationNumber?: string;
  stateMedicalRegistration?: string;
}

export interface WorkspaceInfo {
  isPrivateWorkSpaceAvailable: BooleanTypes;
  maxInternetSpeedAvailable?: number; // stores either as Kbps or mbps
}

// TODO: Move this to the Commons folder (Type for Sign In screen )
export interface SignInRequest {
  phone: {
    countryCode: string;
    number: string;
  };
}
// TODO: Move this to the Commons folder (Type for Sign UP screen )
export interface SignUpRequest {
  phone: {
    countryCode: string;
    number: string;
  };
  email: string;
  firstName: string;
  lastName: string;
  profession: Profession;
  partnerType: LeadType;
  isExternalCommunicationAllowed: string;
}
// TODO: Move this to the Commons folder (Type for OTP Screen )
export interface OtpVerificationRequest {
  otp: string;
  phone: {
    countryCode: string;
    number: string;
  };
}
export enum LeadType {
  INDIVIDUAL = "INDIVIDUAL",
  COMPANY = "COMPANY",
}

export enum Profession {
  DOCTOR = "Doctor",
  THERAPST = "Therapist",
  NUTRITIONIST = "Nutritionist",
  YOGA_TRAINER = "Yoga Trainer",
  PHYSIOTHERAPIST = "Physiotherapist",
  CHEF = "Chef",
  FITNESS_TRAINER = "Fitness Trainer",
  PSYCHIATRIST = "Psychiatrist",
}

export enum LeadState { // to be made in sync with the UI, so as to re-direct them accordingly
  CREATED = "CREATED",
  BASIC_INFO = "BASIC_INFO",
  LANGUAGE_PROFICIENCY_CHECK = "LANGUAGE_PROFICIENCY_CHECK",
  PROFESSIONAL_INFO = "PROFESSIONAL_INFO",
  WORKSPACE_DETAILS = "WORKSPACE_DETAILS",
  SELFIE_VIDEO = "SELFIE_VIDEO",
  PRELIMINARY_QUIZ = "PRELIMINARY_QUIZ",
  PRE_SCREENING_VERIFICATION = "PRE_SCREENING_VERIFICATION",
  CORRECTION = "CORRECTION",
  SLOT_SELECT = "SLOT_SELECT",
  INTERVIEW_SCHEDULED = "INTERVIEW_SCHEDULED",
  INTERVIEW_FEEDBACK = "INTERVIEW_FEEDBACK",
  DIGITAL_COURSES = "DIGITAL_COURSES",
  ILT_TRAINING_SLOT_SELECT = "ILT_TRAINING_SLOT_SELECT",
  ILT_TRAINING_SCHEDULED = "ILT_TRAINING_SCHEDULED",
  SLOT_SELECT_R2 = "SLOT_SELECT_R2",
  INTERVIEW_SCHEDULED_R2 = "INTERVIEW_SCHEDULED_R2",
  INTERVIEW_FEEDBACK_R2 = "INTERVIEW_FEEDBACK_R2",
  FINAL_ASSESSMENT_MODULE = "FINAL_ASSESSMENT_MODULE",
  STAGE_2_VERIFICATION = "STAGE-2_VERIFICATION",
  KYC_UPLOAD = "KYC_UPLOAD",
  BANK_DETAILS = "BANK_DETAILS",
  PROFILE_SETUP = "PROFILE_SETUP",
  ACCEPT_CONTRACT = "ACCEPT_CONTRACT",
  ACCEPT_TDS = "ACCEPT_TDS",
  LEAD_LIVE = "LEAD_LIVE",
  LEAD_DROPPED = "LEAD_DROPPED",
}

// Interface for showing Confirmation Modal
export interface showeEssageProp {
  showModal: boolean;
  actionButtonClickType?: ButtonClickType;
}

// TODO: Move this to the common package -> Interface for KYCDetails Page [POST]
export interface KYCDetailsPost {
  aadharNumber: string;
  panNumber: string;
  consultationFee: number;
}

// TODO: Move this to the common package -> Interface for KYCDetails Page [POST]
export interface GetKYCDetails {
  aadharDocuments: {
    fileType: assetExtensionsFromServer;
    filename: string;
    uploadType: UploadTypes.AADHAR_CARD;
  }[];
  aadharNumber: string;
  panNumber: string;
}

// TODO: Move this to the common package -> Interface for BankDetails Page [POST]
export interface BankDetailsPost {
  bankAccountNumber: string;
  ifscNumber: string;
  accountHolderName: string;
}

// TODO: Move this to the common package -> Interface for BankDetails Page [POST]
export interface GetBankDetails {
  bankAccountNumber: string;
  ifscNumber: string;
  accountHolderNumber: string;
}

// TODO: Move this to the common package -> Interface for BasicProfileDetails Page [POST]
export interface BasicProfileDetailsPost {
  profilePicture: {
    isUploaded: boolean;
    fileExtension: string;
    filename: UploadTypes.PROFILE_PICTURE;
  };
  profileDescription: string;
}

// TODO: Move this to the common package -> Interface for BasicProfileDetails Page [POST]
export interface GetBasicProfileDetails {
  profileDescription: string;
  profilePicture: {
    fileType: assetExtensionsFromServer;
    filename: string;
    uploadType: UploadTypes.PROFILE_PICTURE;
  };
}

// TODO: Move this to the common package -> Interface for WelcomeAboardDetails Page [POST]
export interface GetWelcomeAboardDetails {
  howToUse: {
    mediaFileURL: string;
    mediatitle: string;
  }[];
  googlePlayLink: string;
  applePlayStoreLink: string;
}

// TODO: Interface for the Status API
export interface LeadStepStatus {
  steps: {
    step: LeadState;
    type: StepType;
  }[];
  currentStep: number; // index of the state in the steps array
}

export enum StepType {
  DASHBOARD = "DASHBOARD",
  FORM = "FORM",
}

export interface HeaderNextType {
  change_state: boolean;
}

export interface ErrorObj {
  message: string;
  title: string;
  type: string;
  meta?: {
    aadharError?: string;
    panError?: string;
  };
}

export interface PhoneNumberWithCountryCodeType {
  phoneNumber: string;
  countryCode: string;
}

// Enum status values for all the fields
export enum FieldRenderState {
  MANDATORY = "MANDATORY", // Required fields on the UI
  OPTIONAL = "OPTIONAL", // Not Required (Not Mandatory) fields on the UI
  DISABLED = "DISABLED",
}

// ENUM values for all the input fields for the stage 1 and 3
export enum RegisterationFields {
  FULL_NAME = "FULL_NAME",
  PROFILE_PICTURE = "PROFILE_PICTURE",
  GENDER = "GENDER",
  EMAIL = "EMAIL",
  PHONE_NUMBER = "PHONE_NUMBER",
  ALLOW_WHATSAPP_COMMUNICATION = "ALLOW_WHATSAPP_COMMUNICATION ",
  ZIPCODE = "ZIPCODE",
  CITY = "CITY",
  STATE = "STATE",
  COUNTRY = "COUNTRY",
  ENGLISH_COMFORTABLITY = "ENGLISH_COMFORTABLITY",
  LANGUAGE_COMFORTABILITY = "LANGUAGE_COMFORTABILITY",
  RELEVANT_EXPERIENCE = "RELEVANT_EXPERIENCE",
  HIGHEST_QUALIFICATION = "HIGHEST_QUALIFICATION",
  MCI_REGISTERATION_NUMBER = "MCI_REGISTERATION_NUMBER",
  CLINIC_ADDRESS = "CLINIC_ADDRESS",
  MEDICAL_REGISTERATION_UPLOAD = "MEDICAL_REGISTERATION_UPLOAD",
  MEDICAL_REGISTERATION_NUMBER = "MEDICAL_REGISTERATION_NUMBER",
  RESUME_UPLOAD = "RESUME_UPLOAD",
  MEDICAL_REGISTERATION_STATE = "MEDICAL_REGISTERATION_STATE",
  GRADUATION_CERTIFICATE = "GRADUATION_CERTIFICATE",
  POST_GRADUATION_CERTIFICATE = "POST_GRADUATION_CERTIFICATE",
  OTHER_CERTIFICATION_CERTIFICATE = "OTHER_CERTIFICATION_CERTIFICATE",
  PRIVATE_WORKPLACE = "PRIVATE_WORKPLACE",
  SELFIE_VIDEO_UPLOAD = "SELFIE_VIDEO_UPLOAD",
  PRELIMINARY_QUIZ = "PRELIMINARY_QUIZ",
  STABLE_INTERNET_CONNECTIVITY = "STABLE_INTERNET_CONNECTIVITY",
  CONSULTATION_FEE = "CONSULTATION_FEE",
  PAN_NUMBER = "PAN_NUMBER",
  AADHAR_NUMBER = "AADHAR_NUMBER",
  AADHAR_NUMBER_UPLOAD = "AADHAR_NUMBER_UPLOAD",
  SCANNED_SIGNATURE_UPLOAD = "SCANNED_SIGNATURE_UPLOAD",
  BANK_ACCOUNT_NUMBER = "BANK_ACCOUNT_NUMBER",
  IFSC_NUMBER = "IFSC_NUMBER",
  PROFILE_PICTURE_UPLOAD = "PROFILE_PICTURE_UPLOAD",
  PROFILE_DESC = "PROFILE_DESC",
  CLINIC_NAME = "CLINIC_NAME",
  CLINIC_CITY = "CLINIC_CITY",
  CLINIC_STATE = "CLINIC_STATE",
  CLINIC_COUNTRY = "CLINIC_COUNTRY",
  CLINIC_ZIP_CODE = "CLINIC_ZIP_CODE",
}

export interface addressType {
  city: string;
  state: string;
  country: string;
}

export enum addressKeyTypes {
  CITY = "city",
  STATE = "state",
  COUNTRY = "country",
}

export enum oust_status {
  PENDING = "PENDING", // Haven't started oust
  STARTED = "STARTED", // Started and in the middle of the course
}

export enum OustAccessTypes {
  CPL = "CPL", // training
  ASSESSMENT = "ASSESSMENT", // test or quiz
}

// Interface for the Error Object in each GET request
export interface ErrorType {
  [fieldId: string]: string;
}

export enum ValidationErrorMessages {
  MEDICAL_REGISTERATION_UPLOAD = "Error! Please re-upload the scanned copy of Medical Registeration",
  GRADUATION_CERTIFICATE = "Error! Please re-upload the scanned copy of Bachelor's Degree",
  POST_GRADUATION_CERTIFICATE = "Error! Please re-upload the scanned copy of Master's Degree",
  OTHER_CERTIFICATION_CERTIFICATE = "Error! Please re-upload the scanned copy of Additional Certification",
}

export interface HowToUseType {
  mediatitle: string;
  mediaFileURL: string;
}
export interface WelcomeAboardScreen {
  howToUse: HowToUseType[];
  playStoreLink?: string;
  appStoreLink?: string;
}
